import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useBrowserClasses } from '@vp/swan';

export const SwanEnabler = props => {
  const { children } = props;
  const browserClassName = useBrowserClasses();

  return (
    <>
      <Helmet htmlAttributes={{ class: browserClassName }} />
      <div>{children}</div>
    </>
  );
};

SwanEnabler.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
